import { render, staticRenderFns } from "./FieldVideosI18n.vue?vue&type=template&id=72664c2a&"
import script from "./FieldVideosI18n.vue?vue&type=script&lang=ts&"
export * from "./FieldVideosI18n.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports